import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "mb-24" }
const _hoisted_2 = { class: "row gx-24 mb-64" }
const _hoisted_3 = {
  key: 0,
  class: "col-6"
}
const _hoisted_4 = { class: "professionals-consultations" }
const _hoisted_5 = { class: "h4 title text-primary mb-32" }
const _hoisted_6 = { class: "fw-normal" }
const _hoisted_7 = { class: "footer" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", {
  class: "icon icon-view-light me-8",
  "aria-hidden": "true"
}, null, -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", {
  class: "icon icon-add me-12",
  "aria-hidden": "true"
}, null, -1)
const _hoisted_10 = {
  key: 1,
  class: "col-6"
}
const _hoisted_11 = { class: "h4 title text-primary mb-32" }
const _hoisted_12 = { class: "fw-normal" }
const _hoisted_13 = { class: "footer" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", {
  class: "icon icon-view-light me-16",
  "aria-hidden": "true"
}, null, -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("span", {
  class: "icon icon-add me-12",
  "aria-hidden": "true"
}, null, -1)
const _hoisted_16 = { class: "row mb-64" }
const _hoisted_17 = { class: "h4 title text-primary mb-16" }
const _hoisted_18 = { key: 0 }
const _hoisted_19 = { class: "row" }
const _hoisted_20 = { class: "col-12" }
const _hoisted_21 = { class: "h4 title text-primary mb-32" }
const _hoisted_22 = { class: "fw-normal" }
const _hoisted_23 = {
  key: 0,
  class: "py-24"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_professional_consultations = _resolveComponent("v-professional-consultations")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_v_button = _resolveComponent("v-button")!
  const _component_the_professional_general_authorizations = _resolveComponent("the-professional-general-authorizations")!
  const _component_the_professional_expedient_measures_list = _resolveComponent("the-professional-expedient-measures-list")!
  const _component_the_professional_expedient_file_treatments_list = _resolveComponent("the-professional-expedient-file-treatments-list")!
  const _component_the_professional_consultation_create = _resolveComponent("the-professional-consultation-create")!
  const _component_the_purchase_authorization_create = _resolveComponent("the-purchase-authorization-create")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        (_ctx.canIndexConsultation)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("h2", _hoisted_5, [
                  _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.$t('Últimas')), 1),
                  _createTextVNode(" " + _toDisplayString(_ctx.$t('consultas')), 1)
                ]),
                _createVNode(_component_v_professional_consultations, {
                  class: "py-12 px-8 mb-24",
                  consultations: _ctx.consultations,
                  "go-show-consultation": true,
                  "show-create-button": true
                }, null, 8, ["consultations"]),
                _createElementVNode("div", _hoisted_7, [
                  _createVNode(_component_router_link, {
                    to: {name: 'professional.expedient.show', params: {
              expedient:  _ctx.currentExpedient.id,
              tabName: 'consultas',
              treatment: _ctx.$route.params.treatment,
              consultation: _ctx.$route.params.consultation
            },
            query: {
              tratamiento: _ctx.currentTreatment?.id,
            }},
                    class: "btn btn-secondary btn-sm me-16 mb-12",
                    "aria-label": _ctx.$t('Ver todas las consultas')
                  }, {
                    default: _withCtx(() => [
                      _hoisted_8,
                      _createTextVNode(" " + _toDisplayString(_ctx.$t('Ver todas las consultas')), 1)
                    ]),
                    _: 1
                  }, 8, ["to", "aria-label"]),
                  (_ctx.can('professional.expedient.consultation.store'))
                    ? (_openBlock(), _createBlock(_component_v_button, {
                        key: 0,
                        variant: "secondary",
                        class: "new-consultation mb-12",
                        "aria-label": this.$t('Nueva consulta'),
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.modalToShow = 'the-professional-consultation-create'))
                      }, {
                        default: _withCtx(() => [
                          _hoisted_9,
                          _createElementVNode("span", null, _toDisplayString(_ctx.$t('Nueva consulta')), 1)
                        ]),
                        _: 1
                      }, 8, ["aria-label"]))
                    : _createCommentVNode("", true)
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.canIndexPurchaseAuthorization)
          ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
              _createElementVNode("h2", _hoisted_11, [
                _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.$t('Últimas')), 1),
                _createTextVNode(" " + _toDisplayString(_ctx.$t('autorizaciones')), 1)
              ]),
              _createVNode(_component_the_professional_general_authorizations),
              _createElementVNode("div", _hoisted_13, [
                _createVNode(_component_router_link, {
                  to: {name: 'professional.expedient.show', params: {
              expedient:  _ctx.currentExpedient.id,
              tabName: 'autorizacion-compra',
              treatment: _ctx.$route.params.treatment,
              consultation: _ctx.$route.params.consultation
            },
            query: {
              tratamiento: _ctx.currentTreatment?.id,
            }},
                  class: "btn btn-secondary btn-sm me-16 mb-12",
                  "aria-label": _ctx.$t('Ver todas las autorizaciones')
                }, {
                  default: _withCtx(() => [
                    _hoisted_14,
                    _createTextVNode(" " + _toDisplayString(_ctx.$t('Ver todas las autorizaciones')), 1)
                  ]),
                  _: 1
                }, 8, ["to", "aria-label"]),
                (_ctx.can('professional.expedient.purchase-authorization.store'))
                  ? (_openBlock(), _createBlock(_component_v_button, {
                      key: 0,
                      variant: "secondary",
                      class: "btn-icon mb-12",
                      "aria-label": _ctx.$t('Nueva autorización de compra'),
                      onClick: _ctx.showPurchaseAuthorizationCreateModal
                    }, {
                      default: _withCtx(() => [
                        _hoisted_15,
                        _createTextVNode(" " + _toDisplayString(_ctx.$t('Nueva autorización de compra')), 1)
                      ]),
                      _: 1
                    }, 8, ["aria-label", "onClick"]))
                  : _createCommentVNode("", true)
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_16, [
        _createElementVNode("h2", _hoisted_17, _toDisplayString(_ctx.$t('Medidas')), 1),
        (!_ctx.can('professional.expedient.measures.form.index'))
          ? (_openBlock(), _createElementBlock("div", _hoisted_18, _toDisplayString(_ctx.$t('No tienes permisos para ver las medidas del paciente')), 1))
          : (_openBlock(), _createBlock(_component_the_professional_expedient_measures_list, { key: 1 }))
      ]),
      _createElementVNode("div", _hoisted_19, [
        _createElementVNode("div", _hoisted_20, [
          _createElementVNode("h2", _hoisted_21, [
            _createElementVNode("span", _hoisted_22, _toDisplayString(_ctx.$t('Histórico')), 1),
            _createTextVNode(" " + _toDisplayString(_ctx.$t('Tratamientos')), 1)
          ]),
          (!_ctx.can('professional.expedient.treatment.index'))
            ? (_openBlock(), _createElementBlock("div", _hoisted_23, _toDisplayString(_ctx.$t('No tienes permisos para ver los tratamientos del paciente')), 1))
            : (_openBlock(), _createBlock(_component_the_professional_expedient_file_treatments_list, {
                key: 1,
                onEmitShowStartAnamnesisModal: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('show-start-anamnesis-modal')))
              }))
        ])
      ])
    ]),
    (_ctx.modalToShow === 'the-professional-consultation-create')
      ? (_openBlock(), _createBlock(_component_the_professional_consultation_create, {
          key: 0,
          onClosed: _cache[2] || (_cache[2] = ($event: any) => (_ctx.modalToShow = null))
        }))
      : _createCommentVNode("", true),
    (_ctx.modalToShow === 'the-purchase-authorization-create')
      ? (_openBlock(), _createBlock(_component_the_purchase_authorization_create, {
          key: 1,
          onPurchaseAuthorizationCreated: _cache[3] || (_cache[3] = ($event: any) => {_ctx.loadPurchaseAuthorizations(); _ctx.modalToShow = null}),
          onClosed: _cache[4] || (_cache[4] = ($event: any) => (_ctx.modalToShow = null))
        }))
      : _createCommentVNode("", true)
  ], 64))
}